import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApiResponseDocument,
  OpalApiRequestParams,
} from '../../schema'

type ReadAssignmentV2Params = OpalApiRequestParams<'ReadAssignmentV2'>
type ReadAssignment2ResponseDocument = OpalApiResponseDocument<
  'ReadAssignmentV2',
  200
>

export const readAssignmentById = (
  params: ReadAssignmentV2Params
): Promise<ReadAssignment2ResponseDocument> => {
  const url = new URL(
    `/workflows/v2/assignments/${params.path.assignment_id}`,
    window.location.origin
  )

  url.search = queryString(params.query)

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
